// logger.js
const log = (...args) => {
    if (process.env.REACT_APP_ENV.toLowerCase() !== "prod" || process.env.REACT_APP_FORCE_LOGGER === "true") {
        console.log(...args);
    }
};

const error = (...args) => {
    if (process.env.REACT_APP_ENV.toLowerCase() !== "prod" || process.env.REACT_APP_FORCE_LOGGER === "true") {
        console.error(...args);
    }
};

const warn = (...args) => {
    if (process.env.REACT_APP_ENV.toLowerCase() !== "prod" || process.env.REACT_APP_FORCE_LOGGER === "true") {
        console.warn(...args);
    }
};

export default { log, error, warn };
  